<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف محتوا
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی محتوا
          <i class="far fa-save"/>
          </span>
          <span v-else>
            افزودن محتوا
                <i class="fas fa-plus"/>
          </span>
        </button>

        <hr>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fas fa-clock"/>
          </div>
          <div class="text-right" slot="content">
            <p><b>تاریخ</b></p>
            {{$dateTimeFormat(item.created_at)}}
          </div>
        </StatsCard>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-primary" slot="header">
            <i class="far fa-kiss-beam"/>
          </div>
          <div class="text-right" slot="content">
            <router-link v-if="item.owner_type === 'STORY' && item.story"
                         :to="{name: 'edit_story', params: {id: item.story.id}}">
              <p><b> {{$typeToPersian(item.owner_type)}}</b></p>
              {{item.story.title || '---'}}
            </router-link>
          </div>
        </StatsCard>
      </div>


      <div v-if="id === 'new'  || ( Object.keys(item).length > 0 )" class="col-12">

        <div class="row">
          <div class="col-12">
            <card class="card" title="اطلاع پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="name">نام</label>
                      <input id="name" type="text" class="form-control" placeholder="نام"
                             v-model="item.name">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="order">ترتیب</label>
                      <input id="order" type="number" class="form-control" placeholder="ترتیب"
                             v-model.number="item.order">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="ownerType">نوع مرجع</label>
                      <appTypeSelect id="ownerType" v-model="item.owner_type"
                                     placeholder="نوع مرجع"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="enable">فعال</label>
                      <fv-switch id="enable" class="form-control d-block" placeholder="فعال"
                                 v-model="item.enabled"/>
                    </div>
                  </div>
                  <div v-if="item.owner_type === 'STORY'" class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="story">داستان</label>
                      <appStorySelect :justId="true" id="story"
                                      placeholder="داستان"
                                      v-model="item.owner_id"/>
                    </div>
                  </div>
                </div>
                <div class="clearfix"/>
              </div>
            </card>
            <card class="card text-right" title="محتوا" >
              <div>
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <appPageBuilder v-model="item.sections" placeholder="محتوا" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>


      </div>


    </div>
  </form>
</template>
<script>
  import Modela from 'modela'
  import contentModel from "../../models/content"
  import {mapActions} from "vuex"
  import {StatsCard} from "@/components/index";
  import appTypeSelect from "../../components/appTypeSelect";
  import appStorySelect from "../../components/appStorySelect";
  import appPageBuilder from "../../components/appPageBuilder";
  export default {
    name: 'edit_content',
    components: {
      appTypeSelect,
      StatsCard,
      appStorySelect,
      appPageBuilder
    },
    data() {
      const {params} = this.$route
      const {id} = params
      return {
        ...mapActions('main', [
          'crud'
        ]),
        id,
        item: {},
        disableEditor: id !== 'new',
      }
    },
    methods: {
      async getData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const content = await this.crud({
            action: 'get',
            section: 'contents',
            id: this.id,
            showError: true
          })

          if (content.data) {
            const result = content.data
            let item = new Modela(contentModel)
            item = item.$clean()
            item = item.$set(result)
            this.item = item.$clean().$export()
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async post() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const newContent = await this.crud({
            action: 'post',
            section: 'contents',
            data: this.item,
            showError: true
          })
          this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'contents'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async put() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const updateContents = await this.crud({
            action: 'put',
            section: 'contents',
            id: this.id,
            data: this.item,
            showError: true
          })
          this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'contents'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async del() {
        if (!await this.$confirmAlert())
          return false
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const deleted = await this.crud({
            action: 'delete',
            section: 'contents',
            id: this.id,
            showError: true
          })
          await this.$successAlert()
          // await this.$router.push({name: 'contents'})
          this.$router.go(-1)
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async submit() {
        if (this.id !== 'new')
          this.put()
        else
          this.post()
      }
    },
    async created() {
      if (this.id !== 'new')
        await this.getData()
      else {
        let item = new Modela(contentModel)
        this.item = item.$clean().$export()
      }
    }
  };
</script>
<style>
</style>
